module.exports = __webpack_public_path__ + "static/media/no-search.69ed6af7.svg";